export { default } from './ImageTeaser';
